/**
 * -----------------------------------------------------------------------------------------------------------
 * Account module
 * -----------------------------------------------------------------------------------------------------------
 */
export const SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO'
export const REMOVE_ACCOUNT_INFO = 'REMOVE_ACCOUNT_INFO'
export const SET_SCHOOL_SEARCH = 'SET_SCHOOL_SEARCH'
export const SET_CLASS_USER_SCHOOL = 'SET_CLASS_USER_SCHOOL'
export const SET_CLASS_USER_LEVEL = 'SET_CLASS_USER_LEVEL'
export const SET_CLASS_USER_FACULT = 'SET_CLASS_USER_FACULT'

export const SET_CLASS_PRO_STATUS = 'SET_CLASS_PRO_STATUS'
export const SET_CLASS_PRO_SCHOOL = 'SET_CLASS_PRO_SCHOOL'
export const SET_CLASS_PRO_LEVEL = 'SET_CLASS_PRO_LEVEL'
export const SET_CLASS_PRO_FACULT = 'SET_CLASS_PRO_FACULT'
export const SET_CLASS_PRO_USER = 'SET_CLASS_PRO_USER'

export const SET_CATEGORY_BLOGS_STATUS = 'SET_CATEGORY_BLOGS_STATUS'
export const SET_CATEGORY_BLOGS_TYPE = 'SET_CATEGORY_BLOGS_TYPE'

export const SET_BLOGS_STATUS = 'SET_BLOGS_STATUS'
export const SET_BLOGS_CATEGORY = 'SET_BLOGS_CATEGORY'

export const SET_COURSES_STATUS = 'SET_COURSES_STATUS'
export const SET_COURSES_TYPE = 'SET_COURSES_TYPE'
export const SET_COURSES_CATEGORY = 'SET_COURSES_CATEGORY'
export const SET_COURSES_TEACHER = 'SET_COURSES_TEACHER'
export const SET_COURSES_HOT = 'SET_COURSES_HOT'
export const SET_COURSES_LEVEL = 'SET_COURSES_LEVEL'
export const SET_COURSES_FACULT = 'SET_COURSES_FACULT'


export const SET_COMMENTS_STATUS = 'SET_COMMENTS_STATUS'
export const SET_COMMENTS_COURSE = 'SET_COMMENTS_COURSE'
export const SET_COMMENTS_LESSON = 'SET_COMMENTS_LESSON'





// WEBPACK FOOTER //
// ./src/store/mutation-types.js